import * as React from 'react';
import { Info } from 'lucide-react';
import { cn } from '@/lib/utils';

interface InfoCardProps {
  children: React.ReactNode;
  className?: string;
}

const InfoCard = React.forwardRef<HTMLDivElement, InfoCardProps>(
  ({ children, className }, ref) => (
    <div
      ref={ref}
      className={cn(
        'flex items-center gap-2 rounded-lg border border-blue-200 bg-blue-50 p-2.5',
        className
      )}
    >
      <Info className="h-4 w-4 flex-shrink-0 text-blue-600" />
      <p className="text-sm text-blue-800">{children}</p>
    </div>
  )
);
InfoCard.displayName = 'InfoCard';

export { InfoCard };